module.exports = __webpack_public_path__ + "static/media/rotation_arrow_turquoise.4d989576.svg";